import { Injectable } from '@angular/core';

@Injectable()
export class ConversationCleanerCommunicationService {
  validForm: boolean;
  isDeleteDisabled: boolean = true;
}
